import { Table, TableCol, TableHeader, TableRow } from "@flightpath/coreui/dist/ui/Table";
import { IUploaderColumnConfig } from "../../types/types";
import React from "react";

export const ExampleTable: React.FC<{ fields: IUploaderColumnConfig[] } & ReactProps> = props => {
  const { fields } = props;
  return (
    <Table className="m-0">
      <TableRow className="p-1">
        {fields.map(field => (
          <>
            <TableHeader className="p-1" style={{ border: "1px solid" }}>
              <span>{field.key}</span>
            </TableHeader>
          </>
        ))}
      </TableRow>
      <TableRow className="p-1">
        {fields.map(field => (
          <>
            <TableCol className="p-2" style={{ border: "1px solid" }}>
              <span>{field.placeholder?.toString()}</span>
            </TableCol>
          </>
        ))}
      </TableRow>
    </Table>
  );
};
